import React from "react";
import "./page-steps.css";

const PageSteps = ({
	steps = [],
	currentStep = 1,
	className = ""
}) => {
	return (
		<div className={`page-steps ${className}`}>
			{steps.map((step, index) => {
				const stepNumber = index + 1;
				const isActive = stepNumber === currentStep;
				const isCompleted = stepNumber < currentStep;

				return (
					<React.Fragment key={step.label}>
						<div
							className={`
								page-steps__item
								${isActive ? "page-steps__item--active" : ""}
								${isCompleted ? "page-steps__item--completed" : ""}
							`}
						>
							<span className="page-steps__circle">
								{stepNumber}
							</span>

							<span className="page-steps__label">
								{step.label}
							</span>
						</div>

						{index < steps.length - 1 && (
							<span className="page-steps__line" />
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default PageSteps;